<template>
  <section>
    <nav class="level">
      <div class="level-left">
        <p
          v-if="travelGroup.is_collaborate_travel_group"
          class="has-text-danger has-text-weight-bold"
        >
          此處修改後不會影響既有訂單，如欲更新訂單金額，請到「活動管理」修改補助設定來強制更新訂單金額
        </p>
      </div>
      <div class="level-right">
        <p class="level-item">
          <b-button
            disabled="disabled"
            type="is-primary"
            icon-left="plus"
            @click="onAdd"
          >
            {{ $t('attributes.add') + $t('attributes.traveler_type') }}
          </b-button>
        </p>
      </div>
    </nav>

    <b-table
      :data="travelerTypes"
      :loading="loading"
      :row-class="row => row.main_price && 'has-background-danger-light'"
      :mobile-cards="false"
      narrowed
      bordered
    >
      <b-table-column
        field="sort"
        :width="80"
        :label="$t('attributes.sort')"
        numeric
        v-slot="props"
      >
        {{ props.row.sort }}
      </b-table-column>

      <b-table-column
        field="main_price"
        :label="$t('attributes.main_price')"
        width="90"
        centered
        v-slot="props"
      >
        <b-radio
          v-model="main_traveler_type"
          :native-value="props.row.id"
          style="margin-top: 0.5rem; margin-right: 0;"
          @input="onSelectMainPrice"
        >
        </b-radio>
      </b-table-column>

      <b-table-column
        field="name"
        :label="$t('attributes.name')"
        v-slot="props"
      >
        {{ props.row.traveler_type.name }}
      </b-table-column>

      <b-table-column
        field="display_name"
        :label="$t('attributes.display_name')"
        v-slot="props"
      >
        {{ props.row.traveler_type.display_name }}
      </b-table-column>

      <b-table-column
        field="type"
        :label="$t('attributes.traveler_bed_type')"
        v-slot="props"
      >
        {{ bedTypeName(props.row.traveler_type.type) }}
      </b-table-column>

      <b-table-column
        field="age_min"
        :label="$t('attributes.age_min')"
        numeric
        v-slot="props"
      >
        {{ props.row.traveler_type.age_min }}
      </b-table-column>

      <b-table-column
        field="age_max"
        :label="$t('attributes.age_max')"
        numeric
        v-slot="props"
      >
        {{ props.row.traveler_type.age_max }}
      </b-table-column>

      <b-table-column
        field="display_flag"
        :label="$t('attributes.want_display')"
        v-slot="props"
      >
        {{ displayStatus(props.row.display_flag) }}
      </b-table-column>

      <b-table-column
        field="price"
        :label="$t('attributes.price')"
        numeric
        v-slot="props"
      >
        {{ props.row.price }}
      </b-table-column>

      <b-table-column :width="140" label="功能" centered v-slot="props">
        <div class="buttons is-centered">
          <b-button
            disabled="disabled"
            type="is-info"
            size="is-small"
            @click.prevent.stop="onModify(props.row)"
          >
            {{ $t('attributes.modify') }}
          </b-button>
          <b-button
            disabled="disabled"
            type="is-danger"
            size="is-small"
            outlined
            @click.prevent.stop="onDelete(props.row)"
          >
            {{ $t('attributes.delete') }}
          </b-button>
        </div>
      </b-table-column>

      <template #empty>
        <section class="section">
          <div v-if="!loading" class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large" />
            </p>
          </div>
        </section>
      </template>
    </b-table>

    <b-modal
      :active.sync="isFormModalActive"
      :can-cancel="['escape', 'x']"
      :width="1200"
      has-modal-card
    >
      <traveler-type-form
        :traveler-type="selectedTravelerType"
        :sending="sending"
        @send="onSend"
      />
    </b-modal>

    <b-loading :active="sending" :is-full-page="false"></b-loading>
  </section>
</template>

<script>
import { TRAVEL_GROUPS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import TravelerTypeForm from './TravelerTypeForm'

export default {
  name: 'TravelerTypeList',
  components: { TravelerTypeForm },

  props: {
    travelGroup: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      code: this.travelGroup.code,

      loading: false,
      travelerTypes: [],
      main_traveler_type: null,

      sending: false,

      isFormModalActive: false,
      selectedTravelerType: null
    }
  },
  watch: {
    travelGroup(newGroup) {
      this.code = newGroup.code
      this.isFormModalActive = false
      this.selectedTravelerType = null
      this.loadTravelerTypesAsync(newGroup.code)
    }
  },
  mounted() {
    this.loadTravelerTypesAsync(this.travelGroup.code)
  },
  methods: {
    async loadTravelerTypesAsync(code) {
      try {
        this.loading = true
        const api = `${TRAVEL_GROUPS_API}/${code}/traveler-types`
        const res = await this.axios.get(api)
        const travelerTypes = res.data.data
        this.travelerTypes = travelerTypes.sort((t1, t2) => t1.sort - t2.sort)

        const main_traveler = travelerTypes.find(t => t.main_price)
        this.main_traveler_type = main_traveler && main_traveler.id
      } catch (e) {
        this.travelerTypes = []
        this.main_traveler_type = null

        notifyService.fetch_error('traveler_type', e)
      } finally {
        this.loading = false
      }
    },
    onAdd() {
      this.selectedTravelerType = {
        id: null,
        sort: 10,
        price: 0,
        display_flag: true,
        traveler_type_id: '',
        traveler_type: {}
      }
      this.isFormModalActive = true
    },
    onModify(item) {
      this.selectedTravelerType = item
      this.isFormModalActive = true
    },
    onSelectMainPrice(id) {
      this.setMainPrice(id)
    },
    onSend(item) {
      if (item.id == null) {
        this.createItem(item)
      } else {
        this.updateItem(item)
      }
    },
    onDelete(item) {
      if (item.main_price === true) {
        notifyService.error(this.$t('message.can_not_delete_main_price'))
        return
      }

      this.$buefy.dialog.confirm({
        message: this.$t('attributes.confirm_delete_with_name', {
          name: item.traveler_type.name
        }),
        focusOn: 'cancel',
        onConfirm: () => {
          this.deleteItem(item)
        }
      })
    },
    async createItem(item) {
      try {
        const api = `${TRAVEL_GROUPS_API}/${this.code}/traveler-types`

        this.sending = true
        const res = await this.axios.post(api, item)
        const travelerType = res.data.data

        const travelerTypes = [...this.travelerTypes, travelerType]
        this.travelerTypes = travelerTypes.sort((t1, t2) => t1.sort - t2.sort)

        this.isFormModalActive = false
        notifyService.success(this.$t('attributes.add_succeed'))
      } catch (e) {
        notifyService.create_error(e)
      } finally {
        this.sending = false
      }
    },
    async updateItem(item) {
      try {
        const api = `${TRAVEL_GROUPS_API}/${this.code}/traveler-types/${item.id}`

        this.sending = true
        const res = await this.axios.put(api, item)
        const travelerType = res.data.data

        const idx = this.travelerTypes.findIndex(t => t.id === travelerType.id)
        const travelerTypes = [...this.travelerTypes]
        travelerTypes[idx] = travelerType
        this.travelerTypes = travelerTypes.sort((t1, t2) => t1.sort - t2.sort)

        this.isFormModalActive = false
        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    },
    async setMainPrice(id) {
      try {
        const api = `${TRAVEL_GROUPS_API}/${this.code}/traveler-types/main-price`

        this.sending = true
        const res = await this.axios.put(api, { id })
        const travelerTypes = res.data.data
        this.travelerTypes = travelerTypes.sort((t1, t2) => t1.sort - t2.sort)

        notifyService.success(this.$t('attributes.update_main_price_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    },
    async deleteItem(item) {
      try {
        const api = `${TRAVEL_GROUPS_API}/${this.code}/traveler-types/${item.id}`

        this.sending = true
        await this.axios.delete(api, item)
        this.travelerTypes = this.travelerTypes.filter(s => s.id !== item.id)

        notifyService.success(this.$t('attributes.delete_succeed'))
      } catch (e) {
        notifyService.delete_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  td {
    vertical-align: middle !important;
  }
}
</style>
